const TeamItem = ({ team, selected, onSelect }) => {
	return (
		<li>
			<label
				htmlFor={`team-id-${team.id}`}
				className="sui-box-selector"
			>
				<input
					type="radio"
					name="team_id"
					value={team.id}
					checked={selected == team.id}
					id={`team-id-${team.id}`}
					onChange={(e) => onSelect(e.target.value)}
				/>
				<span>
					{team.avatar_url ?
						<span
							className="team-avatar"
							aria-hidden="true"
							style={{
								backgroundImage: `url(${team.avatar_url})`
							}}
						></span> :
						<span className="sui-icon-community-people" aria-hidden="true"></span>
					}
					{team.nice_name}
				</span>
			</label>
		</li>
	)
}

export default TeamItem
